"use client"

import type { ReactNode } from "react"

import React, { useState } from "react"
import { twJoin } from "tailwind-merge"

import { twMerge } from "#lib/twMergeConfig"
import SvgInfoBold from "#svgs/semantic icons/InfoBold"

export function CollapsableInfo({
  collapseInfoInitial = false,
  collapsedInfoText,
  children,
  className,
}: {
  className?: string
  collapseInfoInitial?: boolean
  collapsedInfoText?: string
  children: ReactNode
}) {
  const [infoCollapsed, setInfoCollapsed] = useState(collapsedInfoText ? collapseInfoInitial : false)

  return (
    <div
      className={twMerge("mt-2 flex gap-x-2.5 pl-3 xl:gap-x-3.5", collapsedInfoText && "cursor-pointer", infoCollapsed && "pl-6", className)}
      onClick={() => collapsedInfoText && setInfoCollapsed(old => !old)}>
      <SvgInfoBold className={twMerge("h-3.5 w-3.5 min-w-[14px] text-black transition-colors", infoCollapsed && "text-gold-130")} />
      <p className={twJoin("text-[11px] transition-colors xl:text-[12px]", !infoCollapsed && "text-gray-70", infoCollapsed && "text-gold-130")}>
        {infoCollapsed ? collapsedInfoText : children}
      </p>
    </div>
  )
}
